import { render } from "./TwoFactorAuthenticationModal.vue?vue&type=template&id=00a35425&scoped=true"
import script from "./TwoFactorAuthenticationModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationModal.vue?vue&type=script&lang=js"

import "./TwoFactorAuthenticationModal.vue?vue&type=style&index=0&id=00a35425&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a35425"]])

export default __exports__